// removed by extract-text-webpack-plugin
module.exports = {"container":"c-Layout__container","columns":"c-Layout__columns","wrap":"c-Layout__wrap","content":"c-Layout__content"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/Layout/Layout.scss
// module id = 520
// module chunks = 0